import React from 'react';
import { Field, FieldLabel, FieldDescription } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

export default function StepIdentification({ formik, onNext }) {
  const handleNext = async e => {
    e.preventDefault();
    await formik.setTouched({ name: true, description: true });
    const errors = await formik.validateForm();
    if (errors.name) return;
    onNext();
  };

  return (
    <div className="page page--wrap">
      <div className="page__col">
        <form
          className="form form--step-by-step"
          method="post"
          onSubmit={handleNext}
        >
          <div className="page__content mb-12 animate-fade-in">
            <div className="new-questions__header">
              <h2 className="new-questions__title">Identificação</h2>
            </div>

            <div className="flex animate-fade-in flex-col gap-6">
              <Field>
                <FieldLabel htmlFor="name">* Nome</FieldLabel>
                <Input
                  id="name"
                  name="name"
                  type="text"
                  placeholder="Ex: Seletivo 2026"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  aria-invalid={Boolean(formik.touched.name && formik.errors.name)}
                />
                {formik.touched.name && formik.errors.name && <FieldDescription className="text-danger">{formik.errors.name}</FieldDescription>}
              </Field>

              <Field>
                <FieldLabel htmlFor="description">Descrição</FieldLabel>
                <textarea
                  id="description"
                  name="description"
                  rows={4}
                  className="mt-1 w-full rounded border p-2"
                  placeholder="Descreva o processo seletivo..."
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.description && formik.errors.description && <FieldDescription className="text-danger">{formik.errors.description}</FieldDescription>}
              </Field>
            </div>
          </div>

          <div className="flex">
            <Button
              type="submit"
              variant="default"
              size="md"
              wide
            >
              Próximo
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
